import React from 'react';

export const SpeechSquare = ({ className = '' }: { className?: string }) => (
  <svg className={className} width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M1.5 0.75H16.5C16.6381 0.75 16.75 0.861929 16.75 1V13.625C16.75 13.7631 16.6381 13.875 16.5 13.875H3.83249C3.60332 13.875 3.38385 13.9675 3.22386 14.1316L1.25 16.1563V1C1.25 0.861929 1.36193 0.75 1.5 0.75Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path d="M9 3.5L9 8.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
    <path d="M9 10.3077L9 10.8077" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
  </svg>
);
